import CookieUtil from '@/utils/cookieUtil';
import { verifyToken, refreshToken, login, logout } from '@/api/auth';
import { COOKIE_KEYS } from '@/constants';

const state = {
    token: CookieUtil.getCookie(COOKIE_KEYS.TOKEN) || ''
};

const mutations = {
    setToken(state, token) {
        state.token = token;
        CookieUtil.setCookie(COOKIE_KEYS.TOKEN, token);
    },
    removeToken(state) {
        state.token = '';
        CookieUtil.deleteCookie(COOKIE_KEYS.TOKEN);
    },
};

const actions = {
    async login({ commit, rootState }, { phone, password }) {
        try {
            const loginLocation = rootState.ip;
            const data = await login(phone, password, loginLocation);
            if (data.success) {
                commit('setToken', data.data.token);
                return {
                    success: true,
                    message: '登录成功'
                };
            } else {
                return {
                    success: false,
                    message: data.message || '登录失败'
                };
            }
        } catch (error) {
            console.error('登录失败:', error);
            return {
                success: false,
                message: '登录服务暂时不可用，请稍后重试'
            };
        }
    },

    async logout({ commit }) {
        try {
            const data = await logout();
            if (data.success) {
                commit('removeToken');
                commit('user/clearUser', null, { root: true });
                return {
                    success: true,
                    message: '退出登录成功'
                };
            } else {
                return {
                    success: false,
                    message: data.message || '退出登录失败'
                };
            }
        } catch (error) {
            console.error('退出登录失败:', error);
            return {
                success: false,
                message: '登录服务暂时不可用，请稍后重试'
            };
        }
    },
    async verifyToken({ commit }) {
        try {
            const data = await verifyToken();
            if (data.success) {
                // Token有效，不需要操作
            } else {
                commit('removeToken');
                commit('user/clearUser', null, { root: true });
            }
        } catch (error) {
            console.error('Token验证失败:', error);
            commit('removeToken');
            commit('user/clearUser', null, { root: true });
        }
    },
    async refreshToken({ commit}) {
        try {
            const data = await refreshToken();
            if (data.success) {
                const newToken = data.data.token;
                commit('setToken', newToken);
                return { success: true, token: newToken };
            } else {
                return { success: false, message: data.message };
            }
        } catch (error) {
            console.error('Token 刷新失败:', error);
            return { success: false, message: 'Token 刷新失败' };
        }
    },
    updateToken({ commit }, token) {
        commit('setToken', token);
    },
    removeToken({ commit }) {
        commit('removeToken');
    },
};

const getters = {
    getToken: state => state.token,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}; 